module.exports = __webpack_public_path__ + "static/img/deal_16.e84d675d.png";